import React from 'react'
import { DateRange, Range, RangeFocus, RangeKeyDict } from 'react-date-range'
import { Button, ButtonProps, Divider, Flex, PopoverContent } from '@chakra-ui/core'

import colors from 'constants/colors'
import LocaleText from 'components/LocaleText'
import { useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'
import { useDateRangeLocale } from 'hooks/useDateRangeLocale'

interface IProps {
  onChange: (value: RangeKeyDict) => void
  ranges: Range[]
  rangeFocusChange: (focusedDates: RangeFocus) => void
  handleFilter: VoidFunction
  minDateRange?: Date
  maxDateRange?: Date
  selectButtonLiteral: string
  resetButtonLiteral?: string
  resetFilter?: VoidFunction
  className?: string
  applyButtonStyles?: Omit<ButtonProps, 'children'>
  style?: any
  useCustomTranslations?: boolean
}

export const DateRangeContent = ({
  onChange,
  ranges,
  rangeFocusChange,
  handleFilter,
  maxDateRange,
  minDateRange,
  resetButtonLiteral,
  selectButtonLiteral,
  resetFilter,
  className,
  applyButtonStyles,
  style,
  useCustomTranslations = true,
}: IProps) => {
  const theme = useSelector((state: RootState) => state.general.theme)
  const dateRangeLocale = useDateRangeLocale(useCustomTranslations)
  return (
    <PopoverContent
      position="absolute"
      zIndex={999999}
      right={style ? style.right : 'unset'}
      left={style ? style.left : 'unset'}
      top={style ? style.top : 'unset'}
      maxWidth="500px"
      dir="ltr"
      _focus={{ border: 'none' }}
    >
      <DateRange
        onChange={onChange}
        moveRangeOnFirstSelection={true}
        months={2}
        ranges={ranges}
        color={theme?.elementsColor}
        direction="horizontal"
        rangeColors={[theme?.backgroundLight!]}
        minDate={minDateRange}
        maxDate={maxDateRange}
        onRangeFocusChange={rangeFocusChange}
        className={className}
        locale={dateRangeLocale}
      />
      <Divider mx="2.5%" />
      <Flex mb="2" justifyContent="space-between" flexDirection="row-reverse" px="2.5%" width="60%" ml="40%">
        <Button
          onClick={handleFilter}
          background={theme?.elementsColor}
          color={colors.tealLight}
          _hover={{ background: theme?.backgroundLight }}
          width="45%"
          {...applyButtonStyles}
        >
          <LocaleText text={selectButtonLiteral} />
        </Button>
        {!!resetFilter && !!resetButtonLiteral && (
          <Button onClick={resetFilter} width="45%">
            <LocaleText text={resetButtonLiteral} />
          </Button>
        )}
      </Flex>
    </PopoverContent>
  )
}
